<template>
  <w-icon-wrapper
    icon-name='work-initial-assessment-icon'
    :width="22.245"
    :height="24"
    viewBox="0 0 22.245 24"
  >
    <g
      id="_111_Ersteinschätzung_"
      data-name="111_Ersteinschätzung "
      transform="translate(-1802.655 -928.21)"
    >
      <path
        id="Pfad_7"
        data-name="Pfad 7"
        d="M47.555,5.36V2.21H44.1v.03a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1V2.21h-3.45v20h14.9v-.85a1,1,0,0,1,2,0v2.85h-18.9V.21h18.9V5.36a1,1,0,0,1-2,0"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_8"
        data-name="Pfad 8"
        d="M45.925,6.24a1,1,0,0,1-1,1h-9.5a1,1,0,0,1,0-2h9.5a.99.99,0,0,1,1,1"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_9"
        data-name="Pfad 9"
        d="M39.305,11.36H35.43a1,1,0,0,1,0-2h3.875a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_10"
        data-name="Pfad 10"
        d="M39.305,14.86H35.43a1,1,0,0,1,0-2h3.875a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_11"
        data-name="Pfad 11"
        d="M40.305,18.735H35.43a1,1,0,0,1,0-2h4.875a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_12"
        data-name="Pfad 12"
        d="M46.76,10.74a4.434,4.434,0,0,1,3.989,2.466,4.454,4.454,0,0,1-7.978,0A4.434,4.434,0,0,1,46.76,10.74m0-2A6.442,6.442,0,0,0,40.62,13.2a6.451,6.451,0,0,0,12.28,0A6.442,6.442,0,0,0,46.76,8.74"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_13"
        data-name="Pfad 13"
        d="M46.76,10.74a4.434,4.434,0,0,1,3.989,2.466,4.454,4.454,0,0,1-7.978,0A4.434,4.434,0,0,1,46.76,10.74m0-2A6.442,6.442,0,0,0,40.62,13.2a6.451,6.451,0,0,0,12.28,0A6.442,6.442,0,0,0,46.76,8.74"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_14"
        data-name="Pfad 14"
        d="M46.873,11.226a1.811,1.811,0,1,0,1.811,1.811,1.811,1.811,0,0,0-1.811-1.811"
        transform="translate(1772 928)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconInitialAssessment' };
</script>
